module.exports = __webpack_public_path__ + "static/img/looksi.57460ec7.jpg";